<template>
	<div class="select">
		<div class="title" v-text="selectTitle"/>
		<div class="icon" v-html="require('@/assets/icons/sort-down-solid.svg')"/>
		<select v-model="categoryId" @change="update">
			<option v-for="category in categoriesAll" :key="category.id" :value="category.id">
				{{category.name}}
			</option>
		</select>
	</div>
</template>

<script>
import {get} from "lodash";

export default {
	props: {
		categories: {type: Array, required: true}
	},
	data() {
		return {
			categoryId: Number(this.$route.query.category_id) || undefined
		}
	},
	computed: {
		categoriesAll: (t) => [{name: "Alle kategorier", id: undefined}, ...t.categories],
		category: (t) => t.categoriesAll.find(x => x.id === t.categoryId),
		selectTitle: (t) => get(t.category, "name")
	},
	methods: {
		update() {
			this.$emit("update", {query: {category_id: this.categoryId}});
		}
	}
};
</script>

<style lang="scss" scoped>
.select {
	position: relative;
	border-radius: 4px 0 0 4px;

	.title {
		white-space: nowrap;
		text-overflow: ellipsis;
		width: 160px;
		overflow: hidden;
		padding: 0.5em 0;

		@include res(small) {
			width: 86px;
		}
	}

	.icon {
		margin-left: 20px;
		margin-top: -0.1em;

		/deep/ svg {
			width: 8px;
			height: 13px;
		}
	}

	select {
		appearance: none;
		position: absolute;
		left: 0;
		right: 0;
		top: 0;
		bottom: 0;
		width: 100%;
		height: 100%;
		opacity: 0;
	}
}
</style>
